export default __webpack_public_path__ + "static/media/partners3@2x.3846af7f.png";